import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Dances = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Dances"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddDance = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Dance"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditDance = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Dance"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};
